import { isJSON } from "@/components/fichaInfo/utilities/helpers";

const storeAuth = {
  tokkoBrokerHost: "",
};
async function updateToken() {
  storeAuth.tokkoBrokerHost = localStorage.getItem("tokkoBrokerHost");
  storeAuth.token = localStorage.getItem("jwt");
}

export class ApiError extends Error {
  constructor(message, status, response) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.response = response;
  }
}

class ApiService {
  static async getRequestOptions({
    method,
    requestData,
    query_params = {},
    extraHeaders = {},
  }) {
    const { jwt } = query_params;
    const requestOptions = {
      method,
      // extraHeaders goes first so callers can't override the fixed headers
      // the backend relies on to identify Ficha Info.
      headers: {
        ...extraHeaders,
        "Content-Type": "application/json",
        // User-Agent personalized for Ficha Info
        "User-Agent": "tokkoBroker-fichaInfo",
      },
      cache: "no-store",
    };
    if (jwt) {
      requestOptions.headers.Authorization = `Bearer ${jwt}`;
    }
    if (requestData) {
      requestOptions.body = JSON.stringify(requestData);
    }

    return requestOptions;
  }

  static async performRequestServer(url, requestOptions, baseUrl) {
    const composedURL = `${baseUrl || process.env.TOKKO_HOST}${url}`;
    const response = await fetch(composedURL, requestOptions);
    let data;

    if (process.env.NODE_ENV !== "test") {
      if (response.headers.get("Content-Type") === "application/json") {
        data = await response.json();
      } else {
        const text = await response.text();
        data = isJSON(text) ? JSON.parse(text) : {};
      }
    } else {
      data = await response.json();
    }

    if (!response.ok) {
      const errorMessage = data.message || data.error || 'Request failed';
      // Lanzar error personalizado con status code para mejor manejo
      throw new ApiError(errorMessage, response.status, data);
    }

    return data;
  }

  static async get(
    url,
    query_params,
    baseUrl = storeAuth.tokkoBrokerHost,
    extraHeaders = {}
  ) {
    const requestOptions = await this.getRequestOptions({
      method: "GET",
      query_params,
      extraHeaders,
    });
    return this.performRequestServer(url, requestOptions, baseUrl);
  }

  static async post(url, requestData, jwt, TOKKO_HOST) {
    const requestOptions = await this.getRequestOptions({
      method: "POST",
      requestData,
      query_params: { jwt },
    });
    return this.performRequestServer(url, requestOptions, TOKKO_HOST)
  }

  static async delete(url, requestData, jwt, TOKKO_HOST) {
    const requestOptions = await this.getRequestOptions({
      method: "DELETE",
      requestData,
      query_params: { jwt },
    });
    return this.performRequestServer(url, requestOptions, TOKKO_HOST)
  }
}

export default ApiService;
